import { Component } from '@verndale/core';
import axios from 'axios';
import IMask from 'imask';
import serialize from 'form-serialize';
import Choices from 'choices.js';
import Schema from 'validate';
import Url from 'domurl';

// Object.entries entries polyfill

if (!Object.entries) {
  Object.entries = obj => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);

    while(i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
  };
}

const rifLocationKey = 'RIF-LOCATION-KEY';
const rifProgramKey = 'RIF-PROGRAM-KEY';

class Rif extends Component {
  setupDefaults() {
    this.dom = {
      $head: $('head'),
      $sectionHeading: this.el.querySelector('.section-heading__tag'),
      $slider: this.el.querySelector('.rif__steps'),
      $form: this.el.querySelector('.rif__step--one .rif__form'),
      $submitButton: this.el.querySelector('.rif__form .rif__submit'),
      $formLoader: this.el.querySelector('.rif__form .rif__loader'),
      $location: this.el.querySelector('[data-field="location"]'),
      $coutryOfCitizenship: this.el.querySelector(
        '[data-field="country-of-citizenship"]'
      ),
      $studentVisa: this.el.querySelector('[data-field="student-visa"]'),
      $studentVisaRadios: this.el.querySelectorAll(
        '[data-field="student-visa"] [type="radio"]'
      ),
      $address: this.el.querySelector('[data-field="address"] [type="text"]'),
      $zipcode: this.el.querySelector(
        '[data-field="zipcode"] input:not(.oh-no-input)'
      ),
      $phone: this.el.querySelector(
        '[data-field="phone"] input:not(.oh-no-input)'
      ),
      $state: this.el.querySelector('[data-field="state"]'),
      $back: this.el.querySelector('.rif__back'),
      $error: this.el.querySelector('.rif__global-error-wrapper'),
      $ohNoInput: this.el.querySelectorAll('.oh-no-input'),
      title: this.el.querySelector('.section-heading__title'),
      description: this.el.querySelector('.section-heading__description'),
      $inputFields: this.el.querySelectorAll('.rif__field:not([name="zipcode"])[type="text"], .rif__field[type="email"]')
    };
    this.us = '';
    this.emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
    this.isUsCitizen = true;
    this.selectText = this.dom.$location.querySelector('option').innerHTML;
    this.setupMasks();
    this.styleSelect();
    this.getData();
  }

  addListeners() {
    window.addEventListener('fill-rif-from-partial', ::this.fillFromPartial);
    this.dom.$form.addEventListener('submit', ::this.onStep1Submit);
    this.dom.$location.addEventListener('choice', ::this.updatePrograms);
    this.dom.$coutryOfCitizenship.addEventListener(
      'choice',
      ::this.updateVisaFieldDisplay
    );
    if (this.dom.$inputFields && this.dom.$inputFields.length){
      this.dom.$inputFields.forEach(input => {
        input.addEventListener('input', e => {
          const newValue = e.target.value.replace(this.emojiRegex, '');
          if (e.target.value !== newValue) {
            e.target.value = newValue;
          }
        });
      });
    }
  }

  setupMasks() {
    IMask(this.dom.$phone, { mask: '000-000-0000' });
    IMask(this.dom.$zipcode, { mask: '00000' });
  }

  fillFromPartial({ detail: { location, program } }) {
    const rifTop = this.el.offsetTop - 100;
    this.setLocationAndProgram(this.data.locations, location, program, false);
    const supportsNativeSmoothScroll =
      'scrollBehavior' in document.documentElement.style;
    if (!supportsNativeSmoothScroll) {
      return window.scrollTo(0, rifTop);
    }
    window.scrollTo({
      top: rifTop,
      left: 0,
      behavior: 'smooth'
    });
  }

  isHoneypotClean() {
    return !Array.from(this.dom.$ohNoInput).filter(input => input.value)
      .length;
  }

  setDataLayer() {
    const { $sectionHeading, $head } = this.dom;

    const dataLayer = `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': '${this.el.dataset.dataLayerEvent}',
      'visitorType':'${$sectionHeading.innerHTML}'
    });`;

    const script = document.createElement('script');
    script.text = dataLayer;

    $head.prepend(script);
  }

  async onStep1Submit(e) {
    e.preventDefault();
    //if (!this.isHoneypotClean()) return;
    const data = this.getFormObject(e.target);
    const errors = this.createStep1ValidationSchema().validate(data);
    if (errors.length) {
      this.updateFormState(errors, this.dom.$form);
      return;
    }
    this.showLoader();

    try {
      const serverErrors = await this.post();
      if (serverErrors && serverErrors.global) {
        this.handleServerErrors(serverErrors);
        this.hideLoader();
        return;
      }
      this.dom.title.remove();
      this.dom.description.remove();
      this.resetFormStatus(e.target);
      this.el.classList.add('success');
      window.scrollTo({
        top: this.el.offsetTop - 100,
        left: 0,
        behavior: 'smooth'
      });
      if (this.el.dataset.dataLayerEvent) {
        this.setDataLayer();
      }
    } catch (error) {
      this.hideLoader();
    }
  }

  showLoader() {
    $(this.dom.$formLoader).attr({
      'aria-hidden': false,
      hidden: false
    });
    $(this.dom.$submitButton).hide();
  }

  hideLoader() {
    $(this.dom.$formLoader).attr({
      'aria-hidden': true,
      hidden: true
    });
    $(this.dom.$submitButton).show();
  }

  styleSelect() {
    const defaultOptions = {
      itemSelectText: '',
      searchEnabled: false,
      shouldSort: false
    };

    this.locationChoices = new Choices(
      '.rif [data-field="location"] .rif__field--select',
      defaultOptions
    );
    this.locationChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.location);

    this.programChoices = new Choices(
      '.rif [data-field="program"] .rif__field--select',
      defaultOptions
    );
    this.programChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.program);

    this.howDidYouHearChoices = new Choices(
      '.rif [data-field="how-did-you-hear-about-us"] .rif__field--select',
      defaultOptions
    );
    this.howDidYouHearChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.hearAboutUs);

    this.stateChoices = new Choices(
      '.rif [data-field="state"] .rif__field--select',
      defaultOptions
    );
    this.stateChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.state);

    this.provinceChoices = new Choices(
      '.rif [data-field="province"] .rif__field--select',
      defaultOptions
    );

    this.highSchoolGradYear = new Choices(
      '.rif [data-field="high-school-grad-year"] .rif__field--select',
      defaultOptions
    );
    this.highSchoolGradYear.containerOuter.element.setAttribute('aria-label', this.el.dataset.gradYear);

    this.countryOfCitizenshipChoices = new Choices(
      '.rif [data-field="country-of-citizenship"] .rif__field--select',
      defaultOptions
    );
    this.countryOfCitizenshipChoices.containerOuter.element.setAttribute('aria-label', this.el.dataset.countryCitizenship);

  }

  createStep1ValidationSchema() {
    const isPlaceholder = val => val !== 'select';

    const zipcode = val => {
      const length = val.length;
      return length === 5 && val.match(/[0-9]/);
    };

    const checkString = val => Boolean(val.trim().length >= 2);

    const state = val => {
      if (val.length) return true;
      return false;
    };

    const studentVisa = val =>
      this.isUsCitizen || (!this.isUsCitizen && !!val);

    return new Schema({
      'first-name': {
        type: String,
        required: true,
        length: { min: 2 },
        use: { checkString },
        message: {
          required: this.getErrorMessage('first-name', 'required'),
          length: this.getErrorMessage('first-name', 'invalid'),
          checkString: this.getErrorMessage('first-name', 'required')
        }
      },
      'last-name': {
        type: String,
        required: true,
        length: { min: 2 },
        use: { checkString },
        message: {
          required: this.getErrorMessage('last-name', 'required'),
          length: this.getErrorMessage('last-name', 'invalid'),
          checkString: this.getErrorMessage('last-name', 'required')
        }
      },
      'email-address': {
        type: String,
        required: true,
        match: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        message: {
          required: this.getErrorMessage('email-address', 'required'),
          match: this.getErrorMessage('email-address', 'valid')
        }
      },
      location: {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage('location', 'required')
        }
      },
      program: {
        type: String,
        required: true,
        use: { isPlaceholder },
        message: {
          required: this.getErrorMessage('program', 'required'),
          isPlaceholder: this.getErrorMessage('program', 'required')
        }
      },
      phone: {
        type: String,
        required: true,
        match: /[2-9][0-9]{2}-[0-9]{3}-[0-9]{4}/,
        message: {
          required: this.getErrorMessage('phone', 'required'),
          match: this.getErrorMessage('phone', 'valid')
        }
      },
      'how-did-you-hear-about-us': {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage(
            'how-did-you-hear-about-us',
            'required'
          )
        }
      },
      address: {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage('address', 'required')
        }
      },
      city: {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage('city', 'required')
        }
      },
      zipcode: {
        required: true,
        use: { zipcode },
        message: this.getErrorMessage('zipcode', 'required')
      },
      state: {
        use: { state },
        message: this.getErrorMessage('state', 'required')
      },
      'student-visa': {
        use: { studentVisa },
        message: this.getErrorMessage('student-visa', 'required')
      },
      'high-school-grad-year': {
        type: String,
        required: true,
        message: {
          required: this.getErrorMessage('high-school-grad-year', 'required')
        }
      }
    });
  }

  getErrorMessage(field, type) {
    const fieldClass = field === 'student-visa' ? 'rif__radios' : 'rif__field';
    return this.el
      .querySelector(`[data-field=${field}]`)
      .querySelector(`.${fieldClass}`)
      .getAttribute(`data-msg-${type}`);
  }

  getFormObject(form) {
    const obj = {};
    form.querySelectorAll('.rif__field-wrapper').forEach(el => {
      const { field } = el.dataset;
      if (field === 'student-visa') {
        const checked = [...el.querySelectorAll('[type="radio"]')].filter(
          radio => radio.checked
        ).length;
        obj[field] = checked ? 'yes' : '';
      } else {
        obj[field] = el.querySelector('.rif__field').value;
      }
    });

    return obj;
  }

  updateFormState(errors, form) {
    let count = 0;

    this.resetFormStatus(form);

    const disclaimer = this.el.querySelector('.rif__disclaimer');
    if (disclaimer) {
      disclaimer.classList.add('rif__disclaimer--error');
    }

    errors.forEach(err => {
      const field = form.querySelector(`[data-field=${err.path}]`);
      if (field) {
        const error = field.querySelector('.rif__error-wrapper');
        field.classList.add('error');
        if (err.path === 'phone') {
          error.innerHTML = `
            <em class="rif__error">
                <span><svg><use xlink:href="#warning"></use></svg></span>
                Please enter a valid Phone Number
             </em>
            `;
        } else {
          error.innerHTML = `
            <em class="rif__error">
                <span><svg><use xlink:href="#warning"></use></svg></span>
                ${err.message}
            </em>
          `;
        }
        count = count + 1;
      }
    });

    return count;
  }

  resetFormStatus(form) {
    this.dom.$error.innerHTML = '';

    const disclaimer = this.el.querySelector('.rif__disclaimer');
    if (disclaimer) {
      disclaimer.classList.remove('rif__disclaimer--error');
    }

    form.querySelectorAll('.rif__field-wrapper').forEach(el => {
      const error = el.querySelector('.rif__error-wrapper');
      el.classList.remove('error');
      error.innerHTML = '';
    });
  }

  setLocationAndProgram(
    locations,
    newLocation,
    newProgram,
    setLocationChoices = true
  ) {
    const sortChoicesGroups = group =>
      group
        .sort((a, b) => {
          const labelA = a.label.toUpperCase();
          const labelB = b.label.toUpperCase();
          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0;
        })
        .sort((a, b) => a.filterorder - b.filterorder);

    const parsePrograms = (programs = []) => {
      const parsedPrograms = [];
      programs.forEach(program => {
        const programGroupIndex = parsedPrograms.findIndex(
          ({ label }) => label === program.group
        );
        if (programGroupIndex < 0) {
          parsedPrograms.push({
            label: program.group,
            id: program.value,
            filterorder: program.filterorder,
            choices: [
              {
                filterorder: program.filterorder,
                value: program.value,
                label: program.label
              }
            ]
          });
        } else {
          parsedPrograms[programGroupIndex].choices.push({
            value: program.value,
            label: program.label,
            filterorder: program.filterorder
          });
        }
      });
      parsedPrograms.forEach(({ choices }) => sortChoicesGroups(choices));
      sortChoicesGroups(parsedPrograms);
      return parsedPrograms;
    };

    if (locations && locations.length) {
      // Parsed locations
      const parsedLocations = [];
      locations.forEach(location => {
        const locationGroupIndex = parsedLocations.findIndex(
          ({ label }) => label === location.group
        );
        if (locationGroupIndex < 0) {
          parsedLocations.push({
            label: location.group,
            filterorder: location.filterorder,
            id: location.group,
            choices: [
              {
                value: location.value,
                label: location.label,
                customProperties: parsePrograms(location.programs)
              }
            ]
          });
        } else {
          parsedLocations[locationGroupIndex].choices.push({
            value: location.value,
            label: location.label,
            customProperties: parsePrograms(location.programs)
          });
        }
      });
      parsedLocations.forEach(({ choices }) => sortChoicesGroups(choices));
      sortChoicesGroups(parsedLocations);
      // Set locations
      if (setLocationChoices) {
        this.locationChoices
          .setChoices(parsedLocations, 'value', 'label', false)
          .enable();
      }

      // Set default values if newLocation exists
      if (newLocation) {
        let location, program;
        parsedLocations.forEach(({ choices }) => {
          const _location = choices.find(
            ({ value }) => value.toLowerCase() === newLocation.toLowerCase()
          );
          if (_location) location = _location;
        });
        // Set default default location if exists
        if (!location) return;
        this.locationChoices.setChoiceByValue(newLocation);
        // Set location programs
        const programs = location.customProperties;
        this.programChoices
          .setValue({ label: this.selectText, value: 'select' })
          .setChoices(programs, 'value', 'label', true)
          .enable();
        // Set default program if exists
        programs.forEach(({ choices }) => {
          const _program = choices.find(
            ({ value }) => String(value) === String(newProgram)
          );
          if (_program) program = _program;
        });
        if (program) {
          this.programChoices.setChoiceByValue(newProgram);
        }
      }
    }
  }

  storeLocationAndProgramSessionInfo() {
    // Get info from element dataset
    const { currentLocation, currentProgram } = this.el.dataset;
    // Update info only if location exists
    if (currentLocation) {
      window.sessionStorage.setItem(rifLocationKey, currentLocation);
      window.sessionStorage.setItem(rifProgramKey, currentProgram);
    }
  }

  getRifSessionInfo() {
    return {
      location: window.sessionStorage.getItem(rifLocationKey),
      program: window.sessionStorage.getItem(rifProgramKey)
    };
  }

  async getData() {
    const url = this.el.dataset.rifEndpoint;
    const queryString = new Url().query;
    const { location, program } = this.getRifSessionInfo();
    const currentLocation =
      queryString.location || this.el.dataset.currentLocation || location;
    const currentProgram =
      queryString.program || this.el.dataset.currentProgram || program;
    this.storeLocationAndProgramSessionInfo();
    const { data } = await axios.get(url);
    this.data = data;

    this.setLocationAndProgram(data.locations, currentLocation, currentProgram);

    if (data.countries && data.countries.length) {
      this.us = data.countries[0].code;
      this.countryOfCitizenshipChoices
        .setChoices(data.countries, 'code', 'name', false)
        .enable()
        .setChoiceByValue(this.us);
    }

    if (data.states && data.states.length) {
      this.stateChoices
        .setChoices(
          data.states.map(value => ({ value, label: value })),
          'value',
          'label',
          false
        )
        .enable();
    }
  }

  async post() {
    const url = this.dom.$form.action;
    const { data } = await axios.get(url, {
      params: serialize(this.dom.$form, { hash: true })
    });

    return data.errors;
  }

  updatePrograms(e) {
    this.programChoices
      .setValue({ label: this.selectText, value: 'select' })
      .setChoices(e.detail.choice.customProperties, 'value', 'label', true)
      .enable();
  }

  updateVisaFieldDisplay(e) {
    const { value } = e.detail.choice;

    if (value === this.us) {
      this.dom.$studentVisa.classList.add('is-hidden');
      this.isUsCitizen = true;
    } else {
      this.dom.$studentVisa.classList.remove('is-hidden');
      this.isUsCitizen = false;
    }
  }

  handleServerErrors(serverErrors) {
    if (serverErrors.global) {
      this.dom.$error.innerHTML = `<em role="alert" class="rif__global-error">${serverErrors.global}</em>`;
    }
  }
}

export default Rif;
